import React from 'react';
import { LanguageProvider } from './LanguageContext';
import Header from './Header';
import Home from './Home';
import About from './About';
import Skills from './Skills';
import Work from './Work';
import Projects from './Projects';
import Contact from './Contact';
import Footer from './Footer';
import './App.css';
import './global.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Home />
        <About />
        <Skills />
        <Work />
        <Projects />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;